<template>
    <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">

                <div class="modal-content" v-if="register">
                    <div class="modal-header">
                        <h5 class="modal-title">Registro de Carga Secundaria</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        
                        <div>                            
                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="type_load" class="badge badge-primary">Detalle Carga</label>
                                        <vue-bootstrap-typeahead                                        
                                            v-model="load_aux_query"
                                            :data="loads_type"
                                            :serializer="item => item.carga_detail"
                                            @hit="mSelectLoad"
                                            :placeholder="dOPlaceLoad"
                                        />
                                </div>

                                <div class="form-group col-12 col-md-6">
                                    <label for="type_activity" class="badge badge-primary">Tipo de servicio</label>
                                    <input class="form-control" type="text" disabled="disabled" v-model="aux_activity.service" />
                            
                                </div>
                            </div>
                            
                            <transition name="fade" mode="out-in">
                            <div v-if="d_view_passenger">
                                <h6><span class="badge badge-primary">Cantidad Pasajeros</span></h6>
                                    <div class="form-row">
                                        <div class="col-12 col-md-6">
                                            <h6><span class="badge badge-success">Bolivianos</span></h6>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                                </div>
                                                <input type="number" v-model="national_men" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="national_women" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <h6><span class="badge badge-success">Extranjeros</span></h6>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                                </div>
                                                <input type="number" v-model="foreign_men" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                                </div>
                                                <input type="number" v-model="foreign_women" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                        </div>
                                    </div>                        
                                </div>
                                </transition>
                            </div>

                            <transition name="fade" mode="out-in">
                            <div class="form-row" v-if="d_view_kilo">                                    
                                <div class="form-group col-12 col-md-12">
                                    <div class="row">
                                            
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_kilo" class="badge badge-info">Kilos</label>
                                            <input type="number" min="0" v-model="load_cash_kilo" @keyup="calcKiloTonelada" class="form-control" aria-label="Default" placeholder="Kilos" aria-describedby="inputGroup-sizing-default">    
                                        </div>

                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_tonelada" class="badge badge-info">Toneladas</label>
                                            <input type="number" min="0" v-model="load_cash_tonelada" @keyup="calcToneladaKilo" class="form-control" aria-label="Default" placeholder="Toneladas" aria-describedby="inputGroup-sizing-default">
                                        </div>
                                    </div>    
                                    <div class="row">
                                        <div class="form-group col-12 col-md-2">
                                            <label for="input_load" class="badge badge-info">Cantidad</label>
                                            <input type="number" min="0" class="form-control" autocomplete="off" v-model="d_quantity">
                                        </div>

                                        <div class="form-group col-12 col-md-4">
                                            <label for="input_load" class="badge badge-info">Unidad de carga</label>
                                            <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_unit_measurement">
                                                <option v-for="tl in type_load_solid" :value="tl" :key="tl.id">{{tl.detail}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="input_load" class="badge badge-info">Descripcion de la Carga</label>
                                            <input type="text" class="form-control" v-model="description_charge" autocomplete="off">
                                        </div>
                                    </div>                                    
                                </div>
                                <transition name="fade" mode="out-in">
                                    <div class="form-group col-12 col-md-4" v-if="d_view_rodada">
                                        <label for="load_quantity" class="badge badge-info">Cantidad</label>
                                        <input type="number" v-model="d_quantity" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Cantidad">
                                    </div>
                                </transition>
                            </div>
                            </transition>

                            <transition name="fade" mode="out-in">
                            <div class="form-row" v-if="d_view_litro">
                                <div class="form-group col-12 col-md-12">
                                    <div class="row">
                                        <div class="col-6">
                                            <label for="load_cash_kilo" class="badge badge-info">Liquido (litros)</label>
                                            <input type="number" v-model="load_cash_litro" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                        </div>                                        
                                        
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-12 col-md-3">
                                            <label for="input_load" class="badge badge-info">Cantidad</label>
                                            <input type="number" min="0" class="form-control" v-model="d_quantity">
                                        </div>
                                        <div class="form-group col-12 col-md-3">
                                            <label for="input_load" class="badge badge-info">Unidad de carga</label>
                                            
                                            <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_unit_measurement">
                                                <option v-for="tl in type_load_liquid" :value="tl" :key="tl.id" >{{tl.detail}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="input_load" class="badge badge-info">Descripcion de la Carga</label>
                                            <input type="text" class="form-control" v-model="description_charge" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </transition>                                          
                            <!-- <pre>{{ selectedBoat }}</pre>
                            <pre>{{ propulsion_aux }}</pre> -->
                        </div>               
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-success" @click="mValidateCharge"><font-awesome-icon icon="check" size="lg" /></button>
                        <button type="button" class="btn btn-outline-warning" @click="mResetForm"><font-awesome-icon icon="redo-alt" size="lg" /></button>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                    </div>
                </div>

                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Listado de Cargas secundarias</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body table-responsive">
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Carga</th>
                                    <th>Kl</th>                                    
                                    <th>Tn</th>
                                    <th>Litros</th>
                                    <th>Cantidad</th>
                                    <th>Varon Nacional</th>
                                    <th>Mujer Nacional</th>
                                    <th>Varon Extranjero</th>
                                    <th>Mujer Extranjero</th>
                                    <th>---</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(charg, index) in retCharges" :key="charg.enrollment">
                                    <th scope="row">{{ index+1 }}</th>
                                    <td>{{ charg.description_load | mayuscula }}</td>
                                    <td>{{ charg.kilos }}</td>
                                    <td>{{ charg.tonelada }}</td>
                                    <td>{{ charg.litros }}</td>
                                    <td>{{ charg.quantity }}</td>
                                    <td>{{ charg.national_man }}</td>
                                    <td>{{ charg.national_woman }}</td>
                                    <td>{{ charg.foreign_man }}</td>
                                    <td>{{ charg.foreign_woman }}</td>
                                    <td><button class="btn btn-outline-warning" @click="mDeleteCharge(charg)"><font-awesome-icon icon="minus-circle"/> </button></td>
                                </tr>
                            </tbody>
                            
                        </table>                       
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                    </div>
                </div>

            </div>
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');

export default {
    name:'modal-other-ship',
    props:{
        idModal:String,
        register:Boolean
    },
    data() {
        return {
            query: '',
            is_disabled:false,
            load_aux_query:null,
            loads_type:[],
            dOPlaceLoad:'Descripcion Carga',
            actividad:[],
            aux_activity:[],
            national_men:0,
            national_women:0,
            foreign_men:0,
            foreign_women:0,
            load_cash_kilo:0,
            load_cash_tonelada:0,
            load_cash_litro:0,
            d_view_kilo:false,
            d_view_litro:false,
            d_view_passenger:false,
            d_view_rodada:false,
            d_quantity:0,
            type_load_aux:{id:0},
            description_charge:null,
            aux_unit_measurement:{id:0, detail:''}
        }
    },
    mounted(){
        this.mChargeInit();
        this.stopModal();
    },
    computed:{
        retCharges(){            
            // retornamos las cargas registradas
            return this.$store.getters['sChargesSecondary/getChargeSec'];
            // return this.$store.getters.getChargeSec
        }
    },
    watch: {
        // When the query value changes, fetch new results from
        // the API - in practice this action should be debounce
        load_aux_query(loadQuery){            
            // axios.get(`searchLoad/${loadQuery}`)
            axios.get(`searchLoad/${loadQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.loads_type = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        }
        // ,
        // selectedBoat(newValue){
        //     this.query=newValue.enrollment;
        // }
    },
    methods:{
        async mChargeInit(){
        let load_liquid= await axios.get(`globals/liquid?api_token=${Vue.auth.getToken()}`);
        let load_solid= await axios.get(`globals/solid?api_token=${Vue.auth.getToken()}`);
        
        let noOption={
                id:0,
                detail:'NINGUNO'
            };

            this.type_load_liquid=[];
            this.type_load_solid=[];
            this.type_load_liquid.push(noOption);
            this.type_load_solid.push(noOption);

            load_liquid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_liquid.push(auxCharge);
            })

            load_solid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_solid.push(auxCharge);
            })
        },
        mSelectLoad(data){
            // this.type_ship=data.id_master;
            // console.log(data);
            this.actividad.id=data.id;
            this.actividad.detail=data.detail;
            this.actividad.factor=data.factor;
            this.aux_activity.activity=data.master_detail;
            this.aux_activity.service=data.detail;
            this.aux_activity.id_load=data.id_l;
            // this.calculateForm();
            this.viewForm(data.unit_measurement);
        },
        viewForm(data){
            switch(data){
                case 'C':
                    this.d_view_passenger=false;
                    this.d_view_kilo=true;
                    this.d_view_litro=false;
                    this.d_view_rodada=false;
                break;
                case 'L':
                    this.d_view_passenger=false;
                    this.d_view_kilo=false;
                    this.d_view_litro=true;
                    this.d_view_rodada=false;
                break;
                case 'P':
                    this.d_view_passenger=true;
                    this.d_view_kilo=false;
                    this.d_view_litro=false;
                    this.d_view_rodada=false;
                break;
                case 'R':
                    this.d_view_passenger=false;
                    this.d_view_kilo=true;
                    this.d_view_litro=false;
                    this.d_view_rodada=true;
                break;
            }
            
        },
        mDeleteCharge(charge){
            // this.$store.dispatch('deleteShip',enroll);
            this.$store.dispatch('sChargesSecondary/deleteChargeSecondary', charge);
            // this.$store.dispatch('updateShip',true);
        },
        stopModal(){
            $('.modal').modal({
                keyboard: false,
                show:false,
                backdrop:'static'
            });
        },
        mAppendCharge(){
            
            let description_load_aux;
            let d_quantity_aux;
            d_quantity_aux=this.d_quantity ? this.d_quantity : 0;    
                if(this.d_view_rodada){                    
                    description_load_aux=this.load_aux_query;
                }else{
                    description_load_aux=this.load_aux_query ? this.load_aux_query : '';
                }
            
            let newCharge={
                id_load: this.aux_activity.id_load,
                factor_activity:this.actividad.factor ? parseFloat(this.actividad.factor) :0.0,
                service:this.actividad.id,
                type_service:this.actividad.detail,
                kilos: this.load_cash_kilo ? parseFloat(this.load_cash_kilo) : 0,
                tonelada:this.load_cash_tonelada ? parseFloat(this.load_cash_tonelada) : 0,
                litros:this.load_cash_litro ? parseFloat(this.load_cash_litro) :0,
                national_man:this.national_men ? parseInt(this.national_men) : 0,
                national_woman:this.national_women ? parseInt(this.national_women):0,
                foreign_man:this.foreign_men ? parseInt(this.foreign_men) : 0,
                foreign_woman:this.foreign_women ? parseInt(this.foreign_women) : 0,
                quantity:d_quantity_aux,
                description_load:description_load_aux,
                type:'S',
                unit_measurement:this.aux_unit_measurement.id,
                description_measurement:this.aux_unit_measurement.detail,
                quantity_description:this.description_charge
            }

                    
            // aqui considerar que no accedemos a la anterior pantalla por ende no sabemos si el valor del dia es mayor a cero analizar
            // sugerencia crear en el store un parametro que maneje los dias laburados asi sabremos si esta o no habilitado inclusive si se llego a aplicar el metodo de dragado.
            
            this.$store.dispatch('sChargesSecondary/addChargeSecondary', newCharge);
            // this.$store.dispatch('updateShip',true);
            toastr.success('Carga secundaria agregada correctamente', 'Nota');
            this.mResetForm();
        },
        mValidateCharge(){
            let ctrerr=0;
            if( !(this.aux_activity.id_load!==0) ){
                toastr.warning('seleccione una actividad');
                ctrerr++;
            }
            
            if( !(this.actividad.factor>=0) ){
                toastr.warning('seleccione una categoria');
                ctrerr++;
            }

            if( !(this.actividad.id!==0) ){
                toastr.warning('seleccione una carga');
                ctrerr++;
            }

            if( !(this.actividad.detail!==null) ){
                toastr.warning('seleccione una carga');
                ctrerr++;
            }
            if( this.load_cash_kilo <= 0 && this.load_cash_tonelada <= 0 && this.load_cash_litro <= 0 && this.national_men <= 0 && this.national_women <= 0 && this.foreign_men <= 0 && this.foreign_women <= 0 && this.d_quantity <= 0 && this.aux_unit_measurement.id ===0 && this.description_charge === ''){
                toastr.warning('indique la cantidad de la carga');
                ctrerr++;
            }
            
            if(ctrerr==0){
                this.mAppendCharge();
            }
            
            
        },
        mResetForm(){
            this.is_disabled=false;
            this.query=null;
            this.d_view_passenger=false;
            this.d_view_kilo=false;
            this.d_view_litro=false;
            this.d_view_rodada=false;
            this.d_quantity=null;

            this.load_cash_kilo = 0 ; 
            this.load_cash_tonelada = 0 ; 
            this.load_cash_litro = 0 ; 
            this.national_men = 0 ; 
            this.national_women = 0 ; 
            this.foreign_men = 0 ; 
            this.foreign_women = 0 ; 
            this.d_quantity = 0
        },
        calcToneladaKilo(){
            this.load_cash_kilo=this.load_cash_tonelada*1000;
        },
        calcKiloTonelada(){
            this.load_cash_tonelada=this.load_cash_kilo/1000;
        },
        mGetTypeLoad(){
            // console.log(this.type_load_aux);
            if(this.type_load_aux.id === 0 ){
                console.log('es un numero ')
                console.log('desactivamos la cantidad de edicion')
                this.load_temp.disabled_quantity=true;                
            }else{
                console.log('activamos la edicion de la cantidad y deshabilitamos lo demas');
                this.load_temp.disabled_quantity=false;
            }
            
        }
    },
    filters: {
        stringify(value) {
        return JSON.stringify(value, null, 2)
        },
        mayuscula:function(value){
            if (!value) return '';
            return value = value.toUpperCase();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cotizacion/modalOtherCharge.vue